


export const DocIconOptions  = [
    [
    'file_text',
    'wiki',
    'information',

    'book',
    'brand',
    'assets',
    'file_binary',
    'file_code',
    'file_contact',
    'globe',
    'graduation',
    'graph',
    'image',
    'mail_black',
    'mail_read',
    'calendar'
    ]
];

